"use strict";
/**
 * API helper functions for Course endpoints
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.courseApi = void 0;
const apiClient_1 = require("./apiClient");
const validation_1 = require("./validation");
const apiMappers_1 = require("./apiMappers");
exports.courseApi = {
    /**
     * Fetch courses for an organization
     */
    getCoursesByOrganization: (orgId) => {
        (0, validation_1.validateId)(orgId, 'Organization ID');
        return apiClient_1.apiClient.get(`/course/organization/${orgId}`).then(data => data.map(apiMappers_1.mapCourse));
    },
    /**
     * Fetch a single course by ID
     */
    getCourseById: (id) => {
        (0, validation_1.validateId)(id, 'Course ID');
        return apiClient_1.apiClient.get(`/course/${id}`).then(apiMappers_1.mapCourse);
    },
    /**
     * Fetch courses by tenant
     */
    getCoursesByTenant: (tenantId) => {
        (0, validation_1.validateId)(tenantId, 'Tenant ID');
        return apiClient_1.apiClient.get(`/course/tenant/${tenantId}`).then(data => data.map(apiMappers_1.mapCourse));
    },
};
